import { WaterPlusOutlineIcon } from './WaterPlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 74B7C41B-554D-453A-8646-FFAFDF78C3CA
 * name water-plus-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-plus-outline.svg
 * tags
 */
export const DropPlusOutlineIcon = WaterPlusOutlineIcon;
export default DropPlusOutlineIcon